import Autocomplete from "./Autocomplete";

import LocalValueInput from "./LocalValueInput";
import { notNullOrUndefined } from "@/utility/functions";

export default {
  mixins: [Autocomplete, LocalValueInput],
  computed: {
    showCounter() {
      return this.counter != null ? this.counter : false;
    },
    handleInitialValueAllowed() {
      return notNullOrUndefined(this.value);
    }
  },
  methods: {
    async loadItems(search, queryParam) {
      this.loading = true;
      this.items = await this.listApi(search, queryParam);
      this.loading = false;
    },
    buildInitialValueQueryParam() {
      const id = this.returnObject ? this.value[this.itemValue] : this.value;
      return this.idPredicatePath + "=" + id;
    },
    emitInputObject() {
      const selectedItem = this.items.find(item => item[this.itemValue] === this.value);
      this.$emit("inputObject", selectedItem);
    }
  }
};
